export default "__VITE_ASSET__ca404442__"